import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const wrote_endpoints = APIS_ENDPOINTS.lettertranscript

export const request_getallWrote = async ({
  search,
  CurrentPage,
  PageSize,
  type,
  GridType,
  LocationStreet,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  type?: number
  GridType?: number
  LocationStreet?: any
}) => {
  return http.get(
    wrote_endpoints.getall +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}${
        type ? `&type=${type}` : ''
      }${GridType ? `&GridType=${GridType}` : ''}${
        LocationStreet ? `&LocationStreet=${LocationStreet}` : ''
      }`
  )
}

export const request_editwrote = async (data) => {
  return http.post(wrote_endpoints.addtranscripts, data)
}

export const request_seentranscripts = async (id: number) => {
  const formData = new FormData()
  formData.append('Id', id as any)
  return http.put(wrote_endpoints.seentranscripts, formData)
}

export const request_seenalltranscripts = async () => {
  return http.put(wrote_endpoints.seenalltranscripts)
}

export const request_getallseentranscripts = async () => {
  return http.post(wrote_endpoints.getallseentranscripts)
}
